import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import 'react';
import { TextInputField } from '@bucketplace/commerce-admin-ui';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../../contexts/internal/StickyContext.js';
import { useStickyTabContext } from '../../../contexts/internal/StickyTabContext.js';
import '../../../contexts/internal/EditorContext.js';
import '../../../components/Canvas/Canvas.style.js';
import '../../../components/Canvas/PreviewModeContainer.js';
import '../../../components/Duration/DurationInput.js';
import 'react-hook-form';
import '../../../components/FieldItem.js';
import '../../../components/FormGroup/FormGroup.js';
import { LogDataFormGroup } from '../../../components/FormGroup/LogDataFormGroup.js';
import '../../../components/Header/index.js';
import '../../../components/Input/ColorPickerField/index.js';
import '../../../components/Input/URLInput.js';
import '../../../components/Inspector/Inspector.js';
import '../../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../../components/Tooltip/Tooltip.js';
import '../../../components/Toolbar/Toolbar.style.js';
import '../../../components/TreeList/Draggable.js';
import '../../../components/EditorPlaceholder/EditorPlaceholder.js';
import { FormContent } from '../../../components/FormContent.js';
import { InspectorFormProvider } from '../../../components/InspectorFormProvider.js';

var _excluded = ["children"];
function StickyTabItemInspector(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  return jsx(InspectorFormProvider, {
    value: value,
    onChange: onChange
  }, jsx(FormContent, {
    header: "\uD0ED \uC544\uC774\uD15C id",
    required: true
  }, jsx(TextInputField, {
    name: "id",
    placeholder: "\uC575\uCEE4\uB9C1 \uD0C0\uCF13\uC73C\uB85C \uC9C0\uC815\uD560 id\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.",
    width: "100%",
    rules: {
      required: true,
      validate: function validate(value) {
        return value.trim() !== '';
      }
    }
  })), jsx(LogDataInput, {
    value: value
  }));
}
function LogDataInput(_ref2) {
  var value = _ref2.value;
  var _useStickyTabContext = useStickyTabContext(),
    setLogData = _useStickyTabContext.setLogData;
  var _ref3 = value !== null && value !== void 0 ? value : {};
    _ref3.children;
    var others = _objectWithoutProperties(_ref3, _excluded);
  return jsx(LogDataFormGroup, _extends({
    nodeKey: value === null || value === void 0 ? void 0 : value.key
  }, setLogData === null || setLogData === void 0 ? void 0 : setLogData(others)));
}

export { StickyTabItemInspector };
//# sourceMappingURL=StickyTabItem.Inspector.js.map
